import { HttpClient } from '@opallabs/api'
import loadWorkflow from '../loadWorkflow'

const typer = (type, identifier) =>
  type && identifier ? `${type}/${identifier}/` : ''

const deletePhaseItem = ({ identifier, type, workflowId, phaseId, itemId }) =>
  HttpClient().delete(
    `/api/v1/${typer(
      type,
      identifier
    )}workflow/${workflowId}/phases/${phaseId}/phase_items/${itemId}`
  )

const destroyPhaseItem =
  ({ identifier, type, workflowId, phaseId, itemId }) =>
  (dispatch) =>
    deletePhaseItem({
      identifier,
      type,
      workflowId,
      phaseId,
      itemId,
    })
      .then((response) => dispatch(loadWorkflow(response.data)))
      .catch((err) => {
        console.log(err)
        throw err
      })

export default destroyPhaseItem
